import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { initialState } from './StepAccess.state';
import { createActions } from './StepAccess.actions';

export const createStepAccessStore = (jobId) =>
    create(
        immer((set, get) => ({
            ...initialState,
            ...createActions(set, get, jobId),
        })),
    );
